import type { DynamicFilterableField, FilterFieldEntry } from '../types';
import { getFilterFieldType } from './get-filter-field-type';

export const getDynamicFilterEntries = (fields: DynamicFilterableField[]): FilterFieldEntry[] =>
	fields
		.filter((field) => !field.excludeFromFilters)
		.map((field) => ({
			id: field.id,
			type: getFilterFieldType(field.kind),
			name: field.name,
			options: field.select?.map((option) => ({ label: option, value: option })),
			allowedComparators: field.allowedComparators,
			search: field.search,
		}));
